import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import reducers from './reducers'

const middleware = applyMiddleware(thunk)

export default () => {
  const store = createStore(reducers, composeWithDevTools(middleware))

  return store
}
